/**
 * /projects/new/pdf — AI-assisted intake from PM-supplied PDFs (M4.3).
 *
 * Thin route wrapper around the shared <PdfIntakePanel> (page variant). The
 * panel owns the dropzone, extraction, draft review, and create + manifest
 * persistence; this wrapper routes to the created project and wires the
 * "Continue in chat" hand-off into router state. The same panel renders embedded
 * in the calendar's New-project modal.
 */
import { useNavigate } from 'react-router-dom';
import { PdfIntakePanel } from '@/components/intake/PdfIntakePanel';

export function ProjectNewPdf() {
  const navigate = useNavigate();
  return (
    <div className="p-6 max-w-5xl mx-auto space-y-4">
      <PdfIntakePanel
        variant="page"
        onCreated={(p) => navigate(`/projects/${p.id}`)}
        onContinueInChat={(payload) =>
          navigate('/projects/new/chat', { state: { fromPdf: payload } })
        }
      />
    </div>
  );
}
